/**
 * Instant Navigation Path Tracker
 * - Uses a combination of techniques to prevent any flicker of default breadcrumbs
 */

// Execute immediately before DOM is fully loaded
(function() {
  console.log('Instant breadcrumbs script running');
  
  // Store collection data when on collection pages
  if (window.location.pathname.includes('/collections/')) {
    try {
      const pathParts = window.location.pathname.split('/');
      const collectionIndex = pathParts.indexOf('collections');
      
      if (collectionIndex !== -1 && pathParts.length > collectionIndex + 1) {
        const collectionHandle = pathParts[collectionIndex + 1];
        
        // We'll capture the title once DOM is ready
        document.addEventListener('DOMContentLoaded', function() {
          let collectionTitle = '';
          const possibleTitleElements = [
            document.querySelector('h1'),
            document.querySelector('.collection-hero__title'),
            document.querySelector('[data-collection-title]'),
            document.querySelector('.collection__title')
          ];
          
          for (const element of possibleTitleElements) {
            if (element && element.textContent.trim()) {
              collectionTitle = element.textContent.trim();
              // Remove any "Collection:" prefix if present
              collectionTitle = collectionTitle.replace(/^Collection:\s*/i, '');
              break;
            }
          }
          
          // If no title found, create one from the handle
          if (!collectionTitle) {
            collectionTitle = collectionHandle
              .split('-')
              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ');
          }
          
          console.log('Storing collection info:', { handle: collectionHandle, title: collectionTitle });
          localStorage.setItem('lastCollectionHandle', collectionHandle);
          localStorage.setItem('lastCollectionTitle', collectionTitle);
        });
      }
    } catch (e) {
      console.error('Error in collection processing:', e);
    }
  }
  
  // For product pages, immediately hide default breadcrumbs and prepare for replacement
  if (window.location.pathname.includes('/products/')) {
    // First, check if we have collection data
    const collectionHandle = localStorage.getItem('lastCollectionHandle');
    const collectionTitle = localStorage.getItem('lastCollectionTitle');
    
    if (collectionHandle && collectionTitle) {
      console.log('Found collection data, will update breadcrumbs');
      
      // 1. Add style to hide any breadcrumb elements until we can update them
      const style = document.createElement('style');
      style.textContent = '.breadcrumb, [data-breadcrumbs], [aria-label="breadcrumbs"] { opacity: 0 !important; }';
      document.head.appendChild(style);
      
      // 2. Set up a mutation observer to catch breadcrumbs as soon as they appear
      const observer = new MutationObserver(function(mutations) {
        for (const mutation of mutations) {
          if (mutation.addedNodes.length) {
            for (const node of mutation.addedNodes) {
              if (node.nodeType === 1) { // Element node
                // Check if this is a breadcrumb or contains a breadcrumb
                const breadcrumbs = [
                  ...(node.matches('.breadcrumb, [data-breadcrumbs], [aria-label="breadcrumbs"]') ? [node] : []),
                  ...node.querySelectorAll('.breadcrumb, [data-breadcrumbs], [aria-label="breadcrumbs"]')
                ];
                
                if (breadcrumbs.length) {
                  updateBreadcrumbs(breadcrumbs);
                }
              }
            }
          }
        }
      });
      
      // Start observing the document with configured parameters
      observer.observe(document.documentElement, { childList: true, subtree: true });
      
      // 3. Also try to find and update on DOMContentLoaded
      document.addEventListener('DOMContentLoaded', function() {
        const breadcrumbs = document.querySelectorAll('.breadcrumb, [data-breadcrumbs], [aria-label="breadcrumbs"]');
        if (breadcrumbs.length) {
          updateBreadcrumbs(breadcrumbs);
        }
        
        // Remove the hiding style and show our updated breadcrumbs
        style.textContent = '';
      });
      
      // Function to update breadcrumbs with navigation path
      function updateBreadcrumbs(breadcrumbElements) {
        // Get product title from URL initially (will refine later if possible)
        let productTitle = window.location.pathname.split('/').pop()
          .split('-')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
        
        for (const breadcrumb of breadcrumbElements) {
          try {
            // Check if this breadcrumb was already processed
            if (breadcrumb.dataset.processed) continue;
            breadcrumb.dataset.processed = 'true';
            
            // Try to get a better product title if possible
            const pageTitle = document.querySelector('h1');
            if (pageTitle && pageTitle.textContent.trim()) {
              productTitle = pageTitle.textContent.trim();
            }
            
            // Different update methods based on breadcrumb structure
            if (breadcrumb.querySelector('.breadcrumb__list')) {
              // Structured breadcrumbs
              const breadcrumbList = breadcrumb.querySelector('.breadcrumb__list');
              const homeItem = breadcrumbList.querySelector('li:first-child')?.outerHTML || 
                `<li class="breadcrumb__item" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
                  <a href="/" class="breadcrumb__link link" itemprop="item">
                    <span itemprop="name">Home</span>
                  </a>
                  <meta itemprop="position" content="1" />
                </li>`;
                
              breadcrumbList.innerHTML = `
                ${homeItem}
                <li class="breadcrumb__divider" aria-hidden="true">/</li>
                <li class="breadcrumb__item" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
                  <a href="/collections/${collectionHandle}" class="breadcrumb__link link" itemprop="item">
                    <span itemprop="name">${collectionTitle}</span>
                  </a>
                  <meta itemprop="position" content="2" />
                </li>
                <li class="breadcrumb__divider" aria-hidden="true">/</li>
                <li class="breadcrumb__item" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
                  <span itemprop="name">${productTitle}</span>
                  <meta itemprop="position" content="3" />
                </li>
              `;
            } else {
              // Simple breadcrumbs
              breadcrumb.innerHTML = `
                <a href="/" class="breadcrumb__link link">Home</a>
                <span class="breadcrumb__divider" aria-hidden="true">/</span>
                <a href="/collections/${collectionHandle}" class="breadcrumb__link link">${collectionTitle}</a>
                <span class="breadcrumb__divider" aria-hidden="true">/</span>
                <span>${productTitle}</span>
              `;
            }
            
            // Make breadcrumb visible immediately
            breadcrumb.style.opacity = '1';
            console.log('Breadcrumb updated');
          } catch (e) {
            console.error('Error updating breadcrumb:', e);
          }
        }
      }
    }
  }
})();